import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/shared/modal'

const InqueryRequest = ({ children, toggle }) => {
  return (
    <Modal onClose={toggle}>
      <div className="modal-body my-5">{children}</div>
    </Modal>
  )
}

InqueryRequest.propTypes = {
  children: PropTypes.node,
  toggle: PropTypes.func,
}
export default InqueryRequest
